import React from 'react'
import useLoginPage from './hooks/useLoginPage'
import LoginForm from './shared/LoginForm'
import LoginShell from './shared/LoginShell'

export default function LoginPage() {
  const loginProps = useLoginPage()

  return (
    <LoginShell
      eyebrow="Bienvenido de nuevo"
      title="Inicia sesión en tu cuenta"
      subtitle="Ingresa tus credenciales para acceder a Torre de Control."
      alertId={loginProps.alertId}
      toastAlertMessage={loginProps.toastAlertMessage}
      toastAlertSeverity={loginProps.toastAlertSeverity}
      onClearToast={loginProps.clearLoginAlert}
    >
      <LoginForm
        email={loginProps.email}
        setEmail={loginProps.setEmail}
        password={loginProps.password}
        setPassword={loginProps.setPassword}
        emailError={loginProps.emailError}
        passwordError={loginProps.passwordError}
        showPassword={loginProps.showPassword}
        setShowPassword={loginProps.setShowPassword}
        isSubmitting={loginProps.isSubmitting}
        onSubmit={loginProps.login}
        formAlertId={loginProps.alertId}
        formAlertSeverity={loginProps.formAlertSeverity}
        formAlertMessage={loginProps.formAlertMessage}
        onClearFormAlert={loginProps.clearLoginAlert}
      />
    </LoginShell>
  )
}
